module.exports = __webpack_public_path__ + "static/media/ai-power-search.31406d0a.png";